import { useEffect, useRef } from 'react'
import { Props } from './interfaces'
import * as Styled from './styled'

function Toast({ severity, children, heading, isOpen, duration, onClose }: Props) {
  const refToast = useRef<HTMLFuelToastElement>(null)

  useEffect(() => {
    let timelapse: ReturnType<typeof setTimeout>

    if (isOpen && duration) {
      void handleOpenToast()

      timelapse = setTimeout(() => {
        onClose?.()
        /* eslint-disable */
        refToast?.current.close()
      }, duration)
    }

    return () => {
      if (isOpen && duration && timelapse) {
        clearTimeout(timelapse)
        /* eslint-disable */
        refToast?.current.close()
        onClose?.()
      }
    }
  }, [isOpen, duration])

  async function handleOpenToast() {
    await refToast?.current.open()
  }

  return (
    <Styled.Toast severity={severity} ref={refToast} heading={heading} data-testid="toast">
      {children}
    </Styled.Toast>
  )
}

Toast.defaultProps = {
  isOpen: false,
  heading: '',
}

export default Toast
